import { computed, observable } from 'mobx';
import { MobxFieldControl } from '@app/src/common/components/form/MobxFieldControl';
import {
  isRequired,
  MobxField,
  IMobxForm,
  isSameAs,
  lengthIsNotMoreThan,
  MobxFormClass
} from '@app/src/common/components/form/MobxForm';
import NewPasswordFieldControl, {
  NewPasswordField
} from '@app/src/common/components/form/NewPasswordFieldControl';
import notificationService from '@app/src/services/notification-service/NotificationService';
import UserManagementRepository from '@app/src/common/repository/UserManagementRepository';

export type ResetPasswordFormState = ResetPasswordForm & IMobxForm;

class ResetPasswordForm extends MobxFormClass {
  @observable isLoading: boolean = false;

  @isRequired()
  @lengthIsNotMoreThan(128)
  @NewPasswordField()
  newPassword: NewPasswordFieldControl;

  @isRequired()
  @isSameAs('newPassword', 'validation.isNotSame.password')
  @MobxField('')
  confirmPassword: MobxFieldControl;

  @computed get isPasswordStrong(): boolean {
    return (
      this.newPassword.moreThanTenChars &&
      this.newPassword.hasOneNumber &&
      this.newPassword.hasOneUppercaseChar &&
      this.newPassword.hasOneLowercaseChar
    );
  }

  submitForm = async (key: string) => {
    const [accessKey, userId] = key.split('|');

    try {
      this.isLoading = true;
      await UserManagementRepository.resetUserPassword({
        userId,
        accessKey,
        password: this.newPassword.value
      });
      notificationService.successMessage(
        'notification.global.success.password.changed'
      );
    } catch (e) {
      notificationService.errorMessage('reset.pass.form.notification.error');
    }
  };
}

export default ResetPasswordForm;
